import { client } from '@chegg/checkout-sdk';
import { getErrorMessage } from './ErrorUtil';
/**
 * initializes the checkout sdk for a specified component using the provided configuration
 * @param {object}
 * @returns {boolean} true if the sdk was initialized successfully, false otherwise
 */
export var initializeSDK = function initializeSDK(_ref) {
  var authorization = _ref.authorization,
    onError = _ref.onError,
    version = _ref.version,
    componentName = _ref.componentName;
  // Initialize checkout sdk by calling authorize
  var initStatus = client.authorize(authorization);
  if (!initStatus.success) {
    onError(getErrorMessage(componentName, 'Chegg authorization error', version));
    return false;
  } else {
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/CheckoutSdkUtils.js
// module id = 1377
// module chunks = 11